import Request from '../Request';
import EndPoints, { applyPathVariables } from '../EndPoints';
import Methods from '../Methods';
/**
 *
 * @param labelId string
 * @param assetId string
 * @param organisationId string
 * @return {Promise<any>|Promise}
 */
export default (function (labelId, assetId, organisationId) {
    var url = applyPathVariables(EndPoints.ORGANISATION_ASSET_LABELS_DELETE, {
        organisationId: organisationId,
        assetId: assetId,
        labelId: labelId
    });
    var request = new Request({ method: Methods.DELETE, url: url, withCredentials: true, blockUI: true });
    return request.execute();
});
